import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, redirectTo = '/login' }) => {
    const { token, jtoken } = useAuth();
  
    return (token && jtoken) ? children :<Navigate to={redirectTo} />;
  };
export default ProtectedRoute;
